import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as Icons from 'lucide-react';

const CategorySelector = ({ selectedCategories = [], onChange, required = false }) => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/categories`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setCategories(response.data.data || []);
        } catch (error) {
            console.error('Error fetching categories:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleToggleCategory = (categoryId) => {
        const newSelection = selectedCategories.includes(categoryId)
            ? selectedCategories.filter(id => id !== categoryId)
            : [...selectedCategories, categoryId];

        onChange(newSelection);
    };

    if (loading) {
        return (
            <div className="bg-white border border-gray-200 rounded-xl p-5 shadow-sm">
                <div className="flex items-center space-x-2 mb-4">
                    <Icons.Tag className="w-5 h-5 text-purple-500" />
                    <h3 className="font-semibold text-gray-900">
                        Categorización del Cliente {required && <span className="text-red-500">*</span>}
                    </h3>
                </div>
                <p className="text-sm text-gray-500">Cargando categorías...</p>
            </div>
        );
    }

    return (
        <div className="bg-white border border-gray-200 rounded-xl p-3 shadow-sm">
            {/* Compact Header */}
            <div className="flex items-center space-x-2 mb-2 pb-1 border-b border-gray-100">
                <Icons.Tag className="w-4 h-4 text-purple-500" />
                <h3 className="font-semibold text-sm text-gray-900">
                    Categorización {required && <span className="text-red-500">*</span>}
                </h3>
            </div>

            <div className="flex flex-wrap gap-1.5">
                {categories.map((category) => {
                    const isSelected = selectedCategories.includes(category.id);

                    return (
                        <button
                            key={category.id}
                            type="button"
                            onClick={() => handleToggleCategory(category.id)}
                            className={`
                px-2.5 py-1 rounded-full text-xs font-medium transition-all duration-200
                border flex items-center space-x-1.5
                ${isSelected
                                    ? 'shadow-sm transform scale-100'
                                    : 'border-gray-200 hover:border-gray-300 bg-white hover:bg-gray-50'
                                }
              `}
                            style={isSelected ? {
                                backgroundColor: category.color + '20',
                                borderColor: category.color,
                                color: category.color
                            } : {}}
                        >
                            {isSelected && <Icons.Check className="w-4 h-4" />}
                            <span
                                className="w-3 h-3 rounded-full"
                                style={{ backgroundColor: category.color }}
                            />
                            <span>{category.name}</span>
                        </button>
                    );
                })}
            </div>

            {required && selectedCategories.length === 0 && (
                <p className="text-xs text-red-500 mt-2 flex items-center">
                    <Icons.AlertCircle className="w-3 h-3 mr-1" />
                    Debe seleccionar al menos una categoría
                </p>
            )}

            {selectedCategories.length > 0 && (
                <div className="mt-3 pt-3 border-t border-gray-100">
                    <p className="text-xs text-gray-600">
                        <strong>{selectedCategories.length}</strong> categoría(s) seleccionada(s)
                    </p>
                </div>
            )}
        </div>
    );
};

export default CategorySelector;
